import { useEffect } from "react";

const TermsAndConditions = () => {
    // Set page title
  useEffect(() => {
    document.title = "Terms and Conditions - Lawra AI";
    return () => {
      document.title = "Lawra AI - AI Legal Assistant for Lawyers & Law Firms | Save 70-80% Time";
    };
  }, []);

  return (
    <div className="legal-page" style={{ color: '#000000' }}>
      <div className="legal-container">
        <div className="legal-content" style={{ color: '#000000' }}>
          <h1 className="legal-title gold-text">Terms and Conditions</h1>
          <p className="legal-updated">Last Updated: {new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</p>

          <section className="legal-section">
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using the AI for Law Firms platform ("the Platform"), you agree to be bound by these Terms and Conditions. 
              If you do not agree to these terms, please do not use the Platform.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. No Legal Advice Disclaimer</h2>
            <p className="legal-important">
              <strong>IMPORTANT:</strong> The Platform and its AI assistant, Lawra, do NOT provide legal advice. All information, 
              documents, analyses, and outputs generated by the Platform are for informational and educational purposes only. 
              They should not be considered as legal advice or as a substitute for consultation with a qualified legal professional.
            </p>
            <p>
              Users must consult with a licensed attorney for advice specific to their legal matters. The use of this Platform 
              does not create an attorney-client relationship.
            </p>
          </section>

          <section className="legal-section">
            <h2>3. Use of AI Services</h2>
            <p>
              The Platform utilizes artificial intelligence to analyze documents and generate content. While we strive for accuracy, 
              AI-generated content may contain errors, omissions, or inaccuracies. Users are responsible for:
            </p>
            <ul>
              <li>Reviewing all AI-generated content carefully</li>
              <li>Verifying information with qualified legal professionals</li>
              <li>Not relying solely on AI outputs for legal decisions</li>
              <li>Understanding the limitations of AI technology</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. User Accounts</h2>
            <p>
              You are responsible for maintaining the confidentiality of your account credentials and for all activities 
              that occur under your account. You agree to:
            </p>
            <ul>
              <li>Provide accurate and complete information during registration</li>
              <li>Maintain the security of your password</li>
              <li>Notify us immediately of any unauthorized use of your account</li>
              <li>Accept responsibility for all activities under your account</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. Acceptable Use</h2>
            <p>You agree NOT to:</p>
            <ul>
              <li>Use the Platform for any illegal or unauthorized purpose</li>
              <li>Upload malicious code, viruses, or harmful content</li>
              <li>Attempt to gain unauthorized access to the Platform or other users' accounts</li>
              <li>Misrepresent your identity or affiliation</li>
              <li>Use the Platform to infringe on intellectual property rights</li>
              <li>Scrape, data mine, or extract data from the Platform</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>6. Intellectual Property</h2>
            <p>
              All content, features, and functionality of the Platform, including but not limited to text, graphics, 
              logos, and software, are owned by AI for Law Firms and are protected by copyright, trademark, and other 
              intellectual property laws.
            </p>
            <p>
              Documents and content you upload remain your property. By uploading content, you grant us a limited license 
              to process, analyze, and display such content solely for the purpose of providing our services to you.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Limitation of Liability</h2>
            <p>
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, AI FOR LAW FIRMS SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, 
              SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY 
              OR INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES.
            </p>
            <p>
              We do not warrant that the Platform will be uninterrupted, secure, or error-free, or that any defects will be corrected.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Indemnification</h2>
            <p>
              You agree to indemnify and hold harmless AI for Law Firms, its officers, directors, employees, and agents from 
              any claims, damages, losses, liabilities, and expenses (including legal fees) arising out of your use of the Platform 
              or violation of these Terms.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Data and Privacy</h2>
            <p>
              Your use of the Platform is also governed by our Privacy Policy. By using the Platform, you consent to the 
              collection and use of your information as described in the Privacy Policy.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Modifications to Terms</h2>
            <p>
              We reserve the right to modify these Terms at any time. Changes will be effective immediately upon posting 
              to the Platform. Your continued use of the Platform after changes constitutes acceptance of the modified Terms.
            </p>
          </section>

          <section className="legal-section">
            <h2>11. Termination</h2>
            <p>
              We may terminate or suspend your access to the Platform immediately, without prior notice, for any reason, 
              including breach of these Terms. Upon termination, your right to use the Platform will immediately cease.
            </p>
          </section>

          <section className="legal-section">
            <h2>12. Governing Law</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of England and Wales, 
              without regard to its conflict of law provisions.
            </p>
          </section>

          <section className="legal-section">
            <h2>13. Contact Information</h2>
            <p>
              For questions about these Terms and Conditions, please contact us through the Platform's support channels.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
